import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Lock, LockOpen, CheckCircle2 } from "lucide-react";
import { fmtStamp } from "./calendarUtils";

// Conferma (docente del corso) / sblocco (solo master) del calendario di un corso
export const LockControls = ({ meta, isMaster, isOwner, onLock, onUnlock }) => {
  const [ask, setAsk] = useState(null); // "lock" | "unlock"
  const locked = !!meta?.calendar_locked;
  return (
    <div className="space-y-2">
      {locked && (
        <div data-testid="course-locked-banner" className="rounded-lg border-2 border-foreground/70 bg-muted p-3 flex items-start gap-2">
          <Lock size={18} className="shrink-0 mt-0.5" />
          <div className="text-sm">
            <p className="font-semibold text-foreground">Calendario confermato e bloccato</p>
            {meta.locked_by && <p className="text-muted-foreground">Confermato da {meta.locked_by.name} il {fmtStamp(meta.locked_at)}</p>}
            {!isMaster && <p className="text-muted-foreground">Non puoi più generare né modificare lezioni. Solo il master può sbloccarlo.</p>}
          </div>
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {!locked && isOwner && <Button size="sm" data-testid="course-lock-btn" onClick={() => setAsk("lock")}><CheckCircle2 size={14} className="mr-1" /> Conferma calendario</Button>}
        {locked && isMaster && <Button size="sm" variant="outline" data-testid="course-unlock-btn" onClick={() => setAsk("unlock")}><LockOpen size={14} className="mr-1" /> Sblocca calendario</Button>}
      </div>
      <AlertDialog open={!!ask} onOpenChange={(o) => !o && setAsk(null)}>
        <AlertDialogContent data-testid="course-lock-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>{ask === "lock" ? "Confermare il calendario?" : "Sbloccare il calendario?"}</AlertDialogTitle>
            <AlertDialogDescription>
              {ask === "lock"
                ? "Dopo la conferma il calendario di questo corso viene bloccato: non potrai più generare, spostare, annullare o aggiungere lezioni. Solo il master potrà sbloccarlo."
                : "Il docente del corso potrà di nuovo generare e modificare le lezioni."}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="course-lock-cancel">Annulla</AlertDialogCancel>
            <AlertDialogAction data-testid="course-lock-confirm" onClick={() => (ask === "lock" ? onLock() : onUnlock())}>
              {ask === "lock" ? "Conferma e blocca" : "Sblocca"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
